<template>
  <div>
    <p>{{ payload.notes }}</p>
  </div>
</template>
<script>
import TimeHelper from '@/custom/classes/time_helper'
import { mapMutations } from 'vuex'
export default {
  name: 'presence-report-notes-content',
  props: ['payload'],
  data () {
    return {
      time_helper: new TimeHelper()
    }
  },
  methods: {
    openModal () {
      this.create({
        designator: 'presence-report-logout-confirmation',
        component_name: 'PresenceReportLogoutConfirmation',
        login: this.payload.stat_id
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
